/*Form advanced Init*/
$(document).ready(function() {
    'use strict';

    /* Select2 Init*/
    $(".select2-js").select2();

    /* Switchery Init*/
    const elems = Array.prototype.slice.call(document.querySelectorAll('.js-switch'));
    $('.js-switch-1').each(function() {
        new Switchery($(this)[0], $(this).data());
    });

    /* Bootstrap switch Init*/
    $('.bs-switch').bootstrapSwitch('state', true);
    $('#check_box_value').text($("#check_box_switch").bootstrapSwitch('state'));

    $('#check_box_switch').on('switchChange.bootstrapSwitch', function () {
        $("#check_box_value").text($('#check_box_switch').bootstrapSwitch('state'));
    });
});
